import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Katido vekiĝis kaj malkovris ĉe si – la voston.
		</p>
		
		<p class="mb-3">
			Tio estis grandega evento por li; li rigardis al la vosto dekomence nekonfide, preskaŭ time, sed poste sin Ĵetis kaptadi ĝin.
		</p>
		
		<p class="mb-3">
			Observante la gajan, sinforgesan baraktadon de la Katido, oni ne povas kredi, ke tiom da ĝojo povas alporti tiu magra, ĉifoneca, sentaŭga vosteto.
		</p>
		`
	)
}

const itemName = {
	esp: 'Ĝojo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;